import { Box, Container, Heading, Text } from '@chakra-ui/react';

import type { PricingExclusivityBanner } from 'types/pricing';

interface ExclusivityBannerProps {
  banner: PricingExclusivityBanner;
}

/**
 * "EXCLUSIVITÉ STUDIO" banner displayed at the very bottom of the Tarifs
 * page. Black background, large title, body underneath. Hidden when
 * `banner.enabled === false` or all fields are empty.
 */
export function ExclusivityBanner({ banner }: ExclusivityBannerProps) {
  if (!banner.enabled) return null;
  if (!banner.title && !banner.body) return null;

  return (
    <Box bg="gray.900" color="white" py={{ base: 8, md: 12 }} mt={{ base: 6, md: 10 }} borderRadius="lg">
      <Container maxW="900px" textAlign="center">
        {banner.title && (
          <Heading
            as="h2"
            size="lg"
            color="orange.300"
            textTransform="uppercase"
            letterSpacing="widest"
            mb={4}
          >
            {banner.title}
          </Heading>
        )}
        {banner.body && (
          <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.100" whiteSpace="pre-wrap">
            {banner.body}
          </Text>
        )}
      </Container>
    </Box>
  );
}
